import  React,{useState,useEffect} from 'react';
import Button from '@mui/material/Button';
import {TextField,Dialog,DialogActions,DialogContent,DialogContentText,DialogTitle,OutlinedInput,InputLabel,MenuItem,FormControl,Select} from '@mui/material';
import { DataGrid,GridToolbar, itIT } from '@mui/x-data-grid';
import unsplash from "../api/unsplash";

export default function SistemAziende() {
  const [open, setOpen] = useState(false);
  const [id, setID] = useState(0);
  const [clienti,setClienti] = useState([]);
  const [clientiAccorpabili,setClientiAccorpabili] = useState([]);
const [clientiSelezionati,setClientiSelezionati] =useState([])

  const columns = [
    { field: 'ID', headerName: 'ID',hide:true, width: 90 },{ field: 'RagioneSociale', headerName: 'RagioneSociale', width: 1000 }]



  const handleClickOpen = async () => {
    await fetchData();
    setID(0);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleConfirm = () => {
    if(id===0){alert("SELEZIONA PRIMA QUALCOSA PER FAVORE")}
    else{
console.log(clientiSelezionati);
    }

  };
  const handleChange = (event) => {
    setID(event.target.value);
 setClientiAccorpabili(clienti.filter(cliente=>cliente.ID!=event.target.value));
  };
  const searchData = (e) => { // filtro
 


    if(e.target.value == ""){
      setClientiAccorpabili(clienti);
    
   }else{
     var clientiX = []; // popolo l'array 
   var i;
   for (i =0 ;i < clienti.length;i++){
     if (clienti[i].RagioneSociale.toLowerCase().includes((e.target.value.toLowerCase())) &&clienti[i].ID!=id){
       clientiX.push(clienti[i]);
     }
   }
   setClientiAccorpabili(clientiX);
   }
 
   }

    const fetchData = async () =>{
      try {
    
                  let response = await  unsplash.post('clienti',
                                        {auth : "a5d42c3ed7977afa2d8e922569e7940b"},
                                        { headers: {
                                                    'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
                                                   }
                                        } );
                                        setClienti(response.data.data);
                                        setClientiAccorpabili(response.data.data);
      } catch (error) {
        console.error(error.message);
      }
    }

    
  




  return (
    <div>
      <Button variant="outlined" onClick={handleClickOpen}>
       Accorpa Aziende
      </Button>
      <Dialog fullWidth={true} open={open} onClose={handleClose}>
        <DialogTitle>Accorpa Aziende</DialogTitle>
        <DialogContent>
          <DialogContentText>
          </DialogContentText>
          <FormControl fullWidth style={{marginTop:10}}>
        <InputLabel id="demo-simple-select-label">Cliente Padre</InputLabel>
        <Select 
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          
          label="Cliente Padre"
          onChange={handleChange}
        >
            {
                clienti?.map(cliente =><MenuItem value={cliente.ID}>{cliente.RagioneSociale}</MenuItem>)
            }
        </Select>
      </FormControl>
<hr></hr>
<div className="form-outline mb-4 input-group" style={{width:"100%"}}>
<span class="input-group-text bg-transparent">
            <i class="bi bi-search" ></i>
            </span>
<input onChange={searchData} className="form-control form-control-lg border-left-0"/>
     
           
          </div>
<div style={{ height: 400, width: '100%' }}>
      <DataGrid
     
       localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
        rows={clientiAccorpabili}
        columns={columns}
        getRowId={clienti => clienti.ID}
        pageSize={100}
        rowsPerPageOptions={[100]}
        checkboxSelection
        disableSelectionOnClick
        onSelectionModelChange={(ids) => {
          const selectedIDs = new Set(ids);
          const selectedRowData = clientiAccorpabili.filter(riga =>
  
              selectedIDs.has(riga.ID)
          
          );
          setClientiSelezionati(selectedRowData);
        }}
      />
    </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirm}>Accorpa</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}